/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ExistingClientRequest as ModelsV3LoanManagementExistingClientRequest } from '../../models/Models/v3/LoanManagement/existing-client-request';
import { ExistingClientResponseListPagedBaseResponse as ModelsV3LoanManagementExistingClientResponseListPagedBaseResponse } from '../../models/Models/v3/LoanManagement/existing-client-response-list-paged-base-response';

export interface V3LoanManagementClientsSearchPost$Xml$Plain$Params {
  
    /**
     * The search request containing client details and pagination
     */
    body?: ModelsV3LoanManagementExistingClientRequest
}

export function v3LoanManagementClientsSearchPost$Xml$Plain(http: HttpClient, rootUrl: string, params?: V3LoanManagementClientsSearchPost$Xml$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsV3LoanManagementExistingClientResponseListPagedBaseResponse>> {
  const rb = new RequestBuilder(rootUrl, v3LoanManagementClientsSearchPost$Xml$Plain.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+xml');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ModelsV3LoanManagementExistingClientResponseListPagedBaseResponse>;
    })
  );
}

v3LoanManagementClientsSearchPost$Xml$Plain.PATH = '/v3/loan-management/clients-search';
